// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b4c7288","552":"593ce097","861":"56683958"}[chunkId] + ".chunk.js";
};